import styled from "styled-components";

export const MultiAxesLineChart = styled.div`
  width: 100%;
  height: 100%;

  .echarts-for-react {
    height: 100% !important;
  }
`;

export const EmptyText = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  span {
    color: ${(props) => props.theme.colors.black60};
    font-size: 1.6rem;
    font-weight: 500;
  }
`;
